import React from "react";
import { NavLink } from "react-router-dom";

export default function NavItem({ to, label, soon, onClick }) {
  if (soon) {
    return (
      <span className="nav-item soon">
        {label}
        <span className="soon-badge">pronto</span>
      </span>
    );
  }
  return (
    <NavLink
      to={to}
      className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}
      onClick={onClick}
    >
      {label}
    </NavLink>
  );
}
